import { useCallback, useContext } from "react";
import { ProfileContext } from "../context";
import { usePreferences } from "../../Settings/Configuration/hooks/usePreferences";

export const useIsActionDisabled = () => {
    const { user } = useContext(ProfileContext);
    const config = usePreferences("peopleApiConnection");

    const getIsActionDisabled = useCallback((key) => {
        const values = Object.values(config?.[key] || {});
        const allFalse = values.length > 0 && values.every((item) => item === false);
        return user?.isApi && allFalse;
    }, [config, user?.isApi]);

    return getIsActionDisabled;
}
